import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';

import { ErrorFacade } from '@core/modules/error/store/error.facade';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({ providedIn: 'root' })
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private errorFacade: ErrorFacade) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let lastResponse: HttpEvent<any>;
    let err: HttpErrorResponse;

    return next.handle(req).pipe(
      tap((response: HttpEvent<any>) => {
        lastResponse = response;
      }),
      catchError((error: HttpErrorResponse) => {
        err = error;
        if (error.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          this.errorFacade.httpExceptionErrorOccurred(error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          this.errorFacade.httpExceptionErrorOccurred(
            `${error.status}, body was: ${error.error}`
          );
        }

        // If you want to return a new response:
        // return of(new HttpResponse({body: [{name: "Default value..."}]}));

        // If you want to return the error on the upper level:
        return throwError(error);
        // return EMPTY;
      }),
      finalize(() => {
        if (
          req.url.includes('Reservation/Create') &&
          lastResponse.type === HttpEventType.Sent &&
          !err
        ) {
          // last response type was 0, and we haven't received an error
          // eslint-disable-next-line no-console
          console.error({
            message: 'Suspected Reservation/Create cancellation',
            url: req.url,
            cid: req.headers.get('rx-cid'),
            requestid: req.headers.get('rx-requestid'),
            ...lastResponse,
          });
        }
      })
    );
  }
}
